import { ErrorMessage } from "formik";
import PropTypes from 'prop-types';
import React, { Component } from 'react';

class FormikFormControl extends Component {
  static propTypes = {
    fieldName: PropTypes.string.isRequired,
    errors: PropTypes.any.isRequired,
    touched: PropTypes.any.isRequired
  }
  render () {
    const { errors, touched, fieldName, children, className } = this.props

    return (
      <div
        className={className || `form-group ${errors[fieldName] &&
          touched[fieldName] &&
          "has-error"}`}
        style={this.props.style}
      >
        {children}
        <ErrorMessage
          name={fieldName}
          component="span"
          className="help-block"
        />
      </div>
    );
  }
}

export default FormikFormControl